import { CATALOGUE, type RailId, type Selection } from './avatar';
export type LookId = 'coffee' | 'researcher' | 'field' | 'night' | 'artist' | 'space';
export const CHARACTER_LOOKS: Record<LookId, Partial<Record<RailId, string>>> = {
  coffee: { kit: 'hoodie', color: 'ocean', hat: 'softcap', prop: 'mug', boots: 'sneakers', pose: 'breathe', acc: 'none' },
  researcher: { kit: 'labcoat', color: 'moss', hat: 'none', prop: 'notebook', boots: 'runners', pose: 'breathe', acc: 'glasses' },
  field: { kit: 'utility', color: 'sand', hat: 'hardhat', prop: 'wrench', boots: 'workboots', pose: 'wave', acc: 'none' },
  night: { kit: 'bomber', color: 'violet', hat: 'none', prop: 'laptop', boots: 'high tops', pose: 'work', acc: 'cans' },
  artist: { kit: 'poncho', color: 'coral', hat: 'beret', prop: 'tablet', boots: 'runners', pose: 'wave', acc: 'none' },
  space: { kit: 'spacesuit', color: 'graphite', hat: 'helmet', prop: 'robot', boots: 'moonboots', pose: 'cheer', acc: 'none' },
};
/** Presets replace equipment, never the learner's face, hair, tone or body. */
export function characterLook(base: Selection, id: LookId): Selection {
  const next = { ...base };
  for (const [rail, key] of Object.entries(CHARACTER_LOOKS[id])) {
    const part = CATALOGUE.find((r) => r.id === rail)?.parts.find((p) => p.key === key);
    if (part) next[rail as RailId] = part.index;
  }
  return next;
}
